import { render, staticRenderFns } from "./JobSearchCarousel.vue?vue&type=template&id=2d19b8d4&"
import script from "./JobSearchCarousel.vue?vue&type=script&lang=js&"
export * from "./JobSearchCarousel.vue?vue&type=script&lang=js&"
import style0 from "./JobSearchCarousel.vue?vue&type=style&index=0&id=2d19b8d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports